export default __webpack_public_path__ + "static/01-0d4f5a6fd3d4c69aabda4343c6584cc0.gif";